import { isEmpty, isEqual } from "lodash";
import moment from "moment";


export abstract class ReportableBase<TReportableData> {
    private lastSaveKeyName: string;
    private lastReportedJsonKey: string;
    private assetId: string;
    private validityInHours: number;

    constructor(
        lastSaveKeyName: string,
        lastReportedJsonKey: string,
        assetId: string,
        validityInHours: number = 24
    ) {
        this.lastSaveKeyName = lastSaveKeyName;
        this.lastReportedJsonKey = lastReportedJsonKey;
        this.assetId = assetId;
        this.validityInHours = validityInHours;
    }

    protected isAlreadyReported(data: TReportableData): boolean {
        const lastSaveDetails = this.getLastSave();
        const lastReportedJSON = this.getLastReportedJSON();

        if (lastReportedJSON) {
            const newReportCandidate = JSON.stringify(data);

            if (isEqual(newReportCandidate, lastReportedJSON)) {
                return true;
            }
        }

        if (lastSaveDetails) {
            const lastSaveTime = moment(lastSaveDetails.time).format();
            const diffInHours = moment().diff(lastSaveTime, 'hours');

            if (diffInHours < this.validityInHours) {
                return true;
            }
        }

        return false;
    }

    protected getLastSave() {
        const key = `${this.lastSaveKeyName}_${this.assetId}`;
        const value = localStorage.getItem(key);

        if (!isEmpty(value)) {
            return JSON.parse(String(value));
        }

        return null
    }

    protected updateLastSave(): void {
        const key = `${this.lastSaveKeyName}_${this.assetId}`;
        const value = {
            time: moment().format()
        }

        return localStorage.setItem(key, JSON.stringify(value));
    }

    protected getLastReportedJSON(): string | null {
        const key = `${this.lastReportedJsonKey}_${this.assetId}`
        const value = localStorage.getItem(key);

        return value;
    }

    protected updateLastReportedJSON(data: TReportableData): void {
        const key = `${this.lastReportedJsonKey}_${this.assetId}`
        const newValue = JSON.stringify(data);

        return localStorage.setItem(key, newValue);
    }

    public abstract report(data: TReportableData): Promise<boolean>

    public abstract getReportableData(): TReportableData
}